import styled from 'styled-components';

const ProgressNumberLast = styled.span`
	color: #ff6b08;
`;

export default ProgressNumberLast;
